


import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useRole } from "./MangeContextProvide";
import { getAllowedRoutes } from "../utility/constant";
import NotFound from "../page/not-found";
import type { Role } from "../utility/constant";

interface RoleContextType {
  role: Role | null;
  isLoading: boolean;
  isWebhookAllowed?: boolean;
}

const RoleBaseAccess: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { role, isLoading, isWebhookAllowed } = useRole() as RoleContextType;

  const normalize = (path: string) => path.replace(/\/+$/, "") || "/";
  const currentPath = normalize(pathname);

  // 1️⃣ Loading
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // 2️⃣ Not logged in
  if (!role) {
    return <Navigate to="/auth/login" replace />;
  }

  const allowedRoutes = getAllowedRoutes({ role, isWebhookAllowed });

  // 3️⃣ Optional: Smart Default Redirect Logic
  // Instead of hardcoding role names, use allowed routes
  if (!allowedRoutes.some(route => currentPath.startsWith(normalize(route)))) {
    // If customer-type role → show NotFound
    if (role === "customeruser" || role === "customeradmin") {
      return (
        <div className="notauthorized">
          <NotFound />
        </div>
      );
    }

    // If admin-type role → redirect to first allowed page
    if (allowedRoutes.length > 0) {
      return <Navigate to={allowedRoutes[0]} replace />;
    }

    return <Navigate to="/auth/login" replace />;
  }

  // 4️⃣ Authorized
  return <>{children}</>;
};

export default RoleBaseAccess;
